import { PickupParticipantKind, PickupParticipantVariant } from "./types";

export const getListLabels = (
  kind: PickupParticipantKind,
  variant: PickupParticipantVariant,
  translate: (key: string, params?: any) => string,
) => {
  const isSport = kind === "sport";
  const participantKey = isSport ? "sport-participants" : "attraction-participants";
  const participantPlaceholderKey = isSport
    ? "sport-participants-placeholder"
    : "attraction-participants-placeholder";

  return {
    checkIn: translate("checkin.title"),
    pageTitle: translate(`checkin.${participantKey}`),
    detailTitle: translate(`checkin.detail-${isSport ? "sport" : "attraction"}-participant`),
    editTitle: translate(`checkin.edit-${isSport ? "sport" : "attraction"}-participant`),
    no: translate("checkin.no"),
    participantId: translate("checkin.participant-id"),
    fullName: translate("full-name"),
    category: translate("checkin.category"),
    bib: translate("checkin.bib-number"),
    email: translate("email"),
    phone: translate("phone"),
    idCard: translate("checkin.id-card"),
    eventName: translate("checkin.event-name"),
    pickupStatus: translate("checkin.pickup-status"),
    orderCode: translate("order-code"),
    ticketNo: translate("ticket-no"),
    action: translate("action"),
    search: translate("search"),
    selectAll: translate("select-all"),
    moreActions: translate("more-actions"),
    download: translate("checkin.download-participants"),
    downloadForPartner: translate("checkin.download-for-partner"),
    delete: translate("checkin.delete-participants"),
    edit: translate("edit"),
    cancel: translate("btn-cancel"),
    save: translate("btn-save"),
    removePos: translate("checkin.remove-pos-checkin"),
    noData: translate("no-data"),
    deleteConfirm: (amount: number) =>
      translate("checkin.delete-participant-confirm", { amount }),
    searchPlaceholder: translate(`checkin.${participantPlaceholderKey}`),
    eventPlaceholder: translate("checkin.event-options-placeholder"),
    categoryPlaceholder: translate("checkin.category-placeholder"),
    pickupStatusPlaceholder: translate("checkin.pickup-status-placeholder"),
    events: translate("checkin.events"),
  };
};
